function afterRender(callback) {
  requestAnimationFrame(() => requestAnimationFrame(callback));
}

const FocusElementPort = {
  add: function (app) {
    app.ports.focusElement.subscribe((id) => {
      afterRender(() => {
        const element = document.getElementById(id);
        if (!element) return;

        if (element.tabIndex < 0 && !element.hasAttribute("tabindex")) {
          element.setAttribute("tabindex", "-1");
        }
        element.focus();
      });
    });
  },
};

module.exports = FocusElementPort;
